import { IoCarSportOutline, IoHeadset } from "react-icons/io5";
import { MdAttachMoney } from "react-icons/md";
import { BsCarFront, BsFile, BsFileEarmarkText } from "react-icons/bs";
import dashboardScreen from "../assets/images/slide-2.png";
import loginScreen from "../assets/images/slide-1.png";
import facture from "../assets/images/slide-3.png";
import { FiUser } from "react-icons/fi";
import { FaCar, FaRegMoneyBillAlt } from "react-icons/fa";

export const onboardingText = [
    {
      header: "Découvrez votre nouvelle plateforme de paiement",
      text: "Gérez les paiements d'immatriculations et de cartes grises plus facilement avec le nouveau VPC.",
      image: loginScreen,
    },
    {
      header: "Une nouvelle interface pour vos paiements",
      text: "L'interface a été complètement revue pour vous rendre l'utilisation plus facile et plus intuitive.",
      image: dashboardScreen,
    },
    {
      header: "Générez les factures automatiquement",
      text: "Après chaque paiement, imprimez immédiatement les factures sans faire patienter le client.",
      image: facture,
    },
  ];

  export const paymentSteps = [
    {
      position: 1,
      icon: <IoCarSportOutline/>,
      description: "Etape 1 sur 3",
      name: "Informations",
    },
    {
      position: 2,
      icon: <MdAttachMoney/>,
      description: "Etape 2 sur 3",
      name: "Paiement",
    },
    {
      position: 3,
      icon: <BsFileEarmarkText/>,
      description: "Etape 3 sur 3",
      name: "Reçu",
    },
  ];
  export const paymentStepsCertificat = [{
      position: 1,
      icon: <FiUser />,
      description: "Etape 1 sur 3",
      name: "Informations du demandeur",
    },
    {
      position: 2,
      icon: <BsFileEarmarkText/>,
      description: "Etape 2 sur 2",
      name: "Paiement",
    },
    {
      position: 3,
      icon: <BsFileEarmarkText/>,
      description: "Etape 3 sur 3",
      name: "Reçu",
    },
  ]
export const paymentStepsCMC = [{
    position: 1,
    icon: <FiUser />,
    description: "Etape 1 sur 3",
    name: "Informations du client",
  },
  {
    position: 2,
    icon: <BsFileEarmarkText/>,
    description: "Etape 2 sur 3",
    name: "Paiement",
  },
  {
    position: 3,
    icon: <BsFileEarmarkText/>,
    description: "Etape 3 sur 3",
    name: "Reçu",
  },
]
export const paymentStepsAPC = [
  {
    position: 1,
    icon: <FiUser />,
    description: "Etape 1 sur 4",
    name: "Informations du client",
  },
  {
    position: 2,
    icon: <BsCarFront />,
    description: "Etape 2 sur 4",
    name: "Information sur le vehicule",
  },
  {
    position: 3,
    icon: <BsFile />,
    description: "Etape 3 sur 4",
    name: "Documents du vehicule",
  },
  {
    position: 4,
    icon: <BsFileEarmarkText />,
    description: "Etape 4 sur 4",
    name: "Titre de Transport",
  },
];
export const nouvelleStepsAPC = [
  {
    position: 1,
    icon: <FaRegMoneyBillAlt />,
    description: "Etape 1 sur 3",
    name: "Informations du paiement",
  },
  {
    position: 2,
    icon: <FiUser />,
    description: "Etape 2 sur 3",
    name: "Informations sur le client",
  },
  {
    position: 3,
    icon: <BsCarFront />,
    description: "Etape 3 sur 3",
    name: "Information sur le vehicule",
  },
];
export const editionStepsAPC = [
  {
    position: 1,
    icon: <BsCarFront />,
    description: "Etape 1 sur 3",
    name: "Informations sur le vehicule",
  },
  {
    position: 2,
    icon:  <BsFile />,
    description: "Etape 2 sur 3",
    name: "Documents  du vehicule",
  },
  {
    position: 3,
    icon: <BsFileEarmarkText />,
    description: "Etape 3 sur 3",
    name: "Résumé",
  },
];